export const indexContent = {
  en: {
    heroTitle1: 'Create Your',
    heroTitle2: 'Own',
    heroTitleHighlight: 'Fake ID',
    stats: [
      { value: '63,497', label: 'Satisfied Customers' },
      { value: '1,521', label: '5-Star Reviews' },
      { value: '8', label: 'Card Designs' },
      { value: '100%', label: 'Satisfaction Rate' },
    ],
    howItWorks: {
      title: 'How It Works',
      subtitle: 'Get your custom ID card in 3 simple steps',
      steps: [
        { title: 'Choose a Template', desc: 'Browse our collection and select your preferred design' },
        { title: 'Customize', desc: 'Upload your photo and enter your personal details' },
        { title: 'Receive', desc: 'Fast, discrete delivery right to your door' },
      ],
    },
    holograms: {
      subtitle: 'High secure',
      subtitleHighlight: 'hologram',
      subtitleEnd: 'layers on all cards!',
      scanInfo: 'Download the <b>PDF417</b> or <b>QR</b> app to scan your ID!',
    },
    delivery: {
      line1: 'Discrete,',
      line2: 'No Branding',
      line3: '& Free Delivery',
      description: 'Every order is shipped in plain, unmarked packaging. No logos, no branding — just your card delivered safely and privately.',
      cta: 'View all Models',
    },
    testimonials: {
      title: 'What Our Customers',
      titleHighlight: 'Say',
      subtitle: 'Trusted by thousands worldwide',
      cta: 'All Reviews',
    },
    blog: {
      title: 'Blog',
      titleHighlight: '& News',
      subtitle: 'Stay updated with the latest tips, guides, and news',
      posts: [
        {
          title: 'How to Choose the Perfect Novelty ID Design',
          excerpt: 'A comprehensive guide to selecting the right ID design for your needs, from parties to film props.',
          date: 'Dec 28, 2025',
          category: 'Guide',
        },
        {
          title: 'Top 5 Uses for Custom ID Cards',
          excerpt: 'Discover creative and legal ways people use our premium novelty ID cards around the world.',
          date: 'Dec 22, 2025',
          category: 'Tips',
        },
        {
          title: 'New Hologram Technology Coming in 2026',
          excerpt: "We're excited to announce our next-generation hologram technology for even more realistic cards.",
          date: 'Dec 15, 2025',
          category: 'News',
        },
      ],
      readMore: 'Read More',
    },
    faq: {
      title: 'Frequently Asked',
      titleHighlight: 'Questions',
      subtitle: 'Everything you need to know about our fake ID cards and novelty products',
      items: [
        { question: 'How to order a fake ID online safely?', answer: 'Simply choose your card design from our fake ID shop, upload your photo, customize the details, and checkout. We use secure payment processing and discrete shipping worldwide. Your order arrives in plain, unmarked packaging.' },
        { question: 'What makes your fake ID holograms look authentic?', answer: 'Our proprietary hologram technology creates realistic security features that shimmer and change appearance when tilted. Each fake ID card features multi-layer holographic overlays similar to real identification documents.' },
        { question: 'How long does fake ID shipping take worldwide?', answer: 'Standard shipping takes 7-14 business days worldwide. All fake ID orders ship with discrete packaging and no branding. Order tracking is coming soon.' },
        { question: 'Are your novelty identification cards scannable?', answer: 'Yes, all fake ID cards include functional QR codes and barcodes that can be scanned with standard barcode readers and PDF417 apps. Download the PDF417 or QR app to test your card.' },
        { question: 'Can I customize my fake drivers license design?', answer: 'Absolutely! Every field on your novelty drivers license can be customized – name, address, date of birth, photo, and more. Our card builder lets you preview changes in real-time before ordering.' },
        { question: "What's the difference between State ID and Photo ID cards?", answer: 'State ID cards replicate the design of official state identification documents with specific layouts and security features. Photo ID cards are more generic identification cards suitable for various entertainment and novelty purposes.' },
        { question: 'Do you ship fake ID cards to the UK and Europe?', answer: 'Yes! We offer worldwide shipping including UK, Germany, France, Spain, and all European countries. EU orders typically arrive within 7-10 business days with our standard shipping option.' },
        { question: 'Why do customers trust our fake ID shop?', answer: "Since 2007, over 63,000 satisfied customers have trusted Fake-ID.com. Read our 1,500+ verified fake ID reviews to see why we're the most trusted novelty ID shop. We offer quality guarantee with free reprints for any production errors and responsive customer support." },
        { question: 'What payment methods do you accept for fake ID orders?', answer: 'We accept all major credit cards (Visa, Mastercard),  Apple Pay, Google Pay, SEPA bank transfers, and cryptocurrency. All transactions are securely encrypted for your protection.' },
        { question: 'What is the quality of your novelty ID cards?', answer: 'Our premium fake ID cards are printed on 0.8mm PVC – identical thickness to real credit cards. They are waterproof, durable, and feature authentic-looking holograms, UV features, and scannable barcodes.' },
      ],
      footerText: 'Have more questions about our <b>fake ID shop</b>? Check out our',
      guideLink: 'complete guide',
      or: 'or',
      contactLink: 'contact our support team',
      footerEnd: 'Join over <b>63,000 satisfied customers</b> who trust Fake-ID.com for premium novelty identification cards.',
    },
    process: {
      title1: 'IT JUST TAKES',
      title2: 'A MINUTE.',
      steps: [
        'Choose a pre-designed card template.',
        'Personalize your card and add it to the cart.',
        "Submit your order and you're all set.",
      ],
      cta: 'Shop Now',
    },
    partners: {
      title: 'Fake-ID',
      titleHighlight: 'Partners',
      subtitle: 'Trusted by leading brands worldwide',
    },
  },
  de: {
    heroTitle1: 'Erstelle Deinen',
    heroTitle2: '',
    heroTitleHighlight: 'Fake Ausweis',
    stats: [
      { value: '63.497', label: 'Zufriedene Kunden' },
      { value: '1.521', label: '5-Sterne Bewertungen' },
      { value: '8', label: 'Karten-Designs' },
      { value: '100%', label: 'Zufriedenheitsrate' },
    ],
    howItWorks: {
      title: 'So funktioniert\'s',
      subtitle: 'Hol dir deinen individuellen Ausweis in 3 einfachen Schritten',
      steps: [
        { title: 'Vorlage wählen', desc: 'Durchstöbere unsere Sammlung und wähle dein bevorzugtes Design' },
        { title: 'Anpassen', desc: 'Lade dein Foto hoch und gib deine Daten ein' },
        { title: 'Erhalten', desc: 'Schnelle, diskrete Lieferung zu dir nach Hause' },
      ],
    },
    holograms: {
      subtitle: 'Hochsichere',
      subtitleHighlight: 'Hologramm',
      subtitleEnd: '-Schichten auf allen Karten!',
      scanInfo: 'Lade die <b>PDF417</b>- oder <b>QR</b>-App herunter, um deinen Ausweis zu scannen!',
    },
    delivery: {
      line1: 'Diskret &',
      line2: 'Kein Branding,',
      line3: 'Kostenloser Versand',
      description: 'Jede Bestellung wird in unauffälliger, unmarkierter Verpackung verschickt. Keine Logos, kein Branding – deine Karte wird sicher und privat geliefert.',
      cta: 'Alle Modelle ansehen',
    },
    testimonials: {
      title: 'Was unsere Kunden',
      titleHighlight: 'sagen',
      subtitle: 'Weltweit von Tausenden vertraut',
      cta: 'Alle Bewertungen',
    },
    blog: {
      title: 'Blog',
      titleHighlight: '& Neuigkeiten',
      subtitle: 'Bleib auf dem Laufenden mit den neuesten Tipps, Anleitungen und News',
      posts: [
        {
          title: 'Den perfekten Fake Ausweis wählen – Ein Leitfaden',
          excerpt: 'Ein umfassender Leitfaden zur Auswahl des richtigen Ausweis-Designs für deine Bedürfnisse.',
          date: '28. Dez. 2025',
          category: 'Ratgeber',
        },
        {
          title: 'Top 5 Verwendungen für Fake Ausweise',
          excerpt: 'Entdecke kreative Wege, wie Menschen unsere Premium-Ausweise weltweit nutzen.',
          date: '22. Dez. 2025',
          category: 'Tipps',
        },
        {
          title: 'Neue Hologramm-Technologie 2026',
          excerpt: 'Wir freuen uns, unsere nächste Generation der Hologramm-Technologie für noch realistischere Karten anzukündigen.',
          date: '15. Dez. 2025',
          category: 'News',
        },
      ],
      readMore: 'Weiterlesen',
    },
    faq: {
      title: 'Häufig gestellte',
      titleHighlight: 'Fragen',
      subtitle: 'Alles, was du über unsere Fake Ausweise und Novelty-Produkte wissen musst',
      items: [
        { question: 'Wie kann ich einen Fake Ausweis online bestellen?', answer: 'Wähle einfach dein Karten-Design in unserem Fake Ausweis Shop, lade dein Foto hoch, passe die Details an und bestelle. Wir verwenden sichere Zahlungsverarbeitung und diskreten Versand weltweit.' },
        { question: 'Was macht eure Fake Ausweis Hologramme so realistisch?', answer: 'Unsere proprietäre Hologramm-Technologie erzeugt realistische Sicherheitsmerkmale, die beim Kippen schimmern. Jeder Fake Ausweis verfügt über mehrschichtige holografische Overlays.' },
        { question: 'Wie lange dauert der Versand von Fake Ausweisen?', answer: 'Der Standardversand dauert 7-14 Werktage weltweit. Alle Bestellungen werden diskret und ohne Branding versendet. Sendungsverfolgung kommt bald.' },
        { question: 'Sind eure Novelty-Ausweise scanbar?', answer: 'Ja, alle Fake Ausweise enthalten funktionsfähige QR-Codes und Barcodes, die mit Standard-Barcode-Lesern und PDF417-Apps gescannt werden können.' },
        { question: 'Kann ich meinen gefälschten Führerschein individuell gestalten?', answer: 'Absolut! Jedes Feld auf deinem Novelty-Führerschein kann angepasst werden – Name, Adresse, Geburtsdatum, Foto und mehr. Unser Karten-Builder zeigt dir Änderungen in Echtzeit.' },
        { question: 'Was ist der Unterschied zwischen State ID und Photo ID?', answer: 'State ID-Karten replizieren das Design offizieller staatlicher Ausweisdokumente. Photo ID-Karten sind generischere Ausweiskarten für verschiedene Unterhaltungs- und Novelty-Zwecke.' },
        { question: 'Liefert ihr Fake Ausweise nach Deutschland und Europa?', answer: 'Ja! Wir bieten weltweiten Versand an, einschließlich Deutschland, Österreich, Schweiz und alle EU-Länder. EU-Bestellungen kommen in der Regel innerhalb von 7-10 Werktagen an.' },
        { question: 'Warum vertrauen Kunden unserem Fake Ausweis Shop?', answer: 'Seit 2007 vertrauen über 63.000 zufriedene Kunden Fake-ID.com. Lies unsere 1.500+ verifizierten Bewertungen, um zu sehen, warum wir der vertrauenswürdigste Novelty-Ausweis-Shop sind.' },
        { question: 'Welche Zahlungsmethoden akzeptiert ihr?', answer: 'Wir akzeptieren alle gängigen Kreditkarten (Visa, Mastercard),  Apple Pay, Google Pay, SEPA-Überweisungen und Kryptowährung. Alle Transaktionen sind verschlüsselt.' },
        { question: 'Wie ist die Qualität eurer Novelty-Ausweise?', answer: 'Unsere Premium Fake Ausweise werden auf 0,8mm PVC gedruckt – identische Dicke wie echte Kreditkarten. Sie sind wasserfest, langlebig und verfügen über authentisch aussehende Hologramme und scanbare Barcodes.' },
      ],
      footerText: 'Hast du weitere Fragen zu unserem <b>Fake Ausweis Shop</b>? Schau dir unseren',
      guideLink: 'vollständigen Leitfaden',
      or: 'an oder',
      contactLink: 'kontaktiere unser Support-Team',
      footerEnd: 'Schließ dich über <b>63.000 zufriedenen Kunden</b> an, die Fake-ID.com für Premium Novelty-Ausweise vertrauen.',
    },
    process: {
      title1: 'ES DAUERT NUR',
      title2: 'EINE MINUTE.',
      steps: [
        'Wählen Sie eine vorgefertigte Kartenvorlage.',
        'Personalisieren Sie Ihre Karte und legen Sie sie in den Warenkorb.',
        'Senden Sie Ihre Bestellung ab – fertig!',
      ],
      cta: 'JETZT KAUFEN',
    },
    partners: {
      title: 'Fake-ID',
      titleHighlight: 'Partner',
      subtitle: 'Vertraut von führenden Marken weltweit',
    },
  },
  es: {
    heroTitle1: 'Crea Tu',
    heroTitle2: 'Propia',
    heroTitleHighlight: 'ID Falsa',
    stats: [
      { value: '63.497', label: 'Clientes Satisfechos' },
      { value: '1.521', label: 'Reseñas 5 Estrellas' },
      { value: '8', label: 'Diseños de Tarjetas' },
      { value: '100%', label: 'Tasa de Satisfacción' },
    ],
    howItWorks: {
      title: 'Cómo Funciona',
      subtitle: 'Obtén tu identificación personalizada en 3 simples pasos',
      steps: [
        { title: 'Elige una Plantilla', desc: 'Explora nuestra colección y selecciona tu diseño preferido' },
        { title: 'Personaliza', desc: 'Sube tu foto e ingresa tus datos personales' },
        { title: 'Recibe', desc: 'Entrega rápida y discreta en tu puerta' },
      ],
    },
    holograms: {
      subtitle: 'Capas de',
      subtitleHighlight: 'holograma',
      subtitleEnd: 'de alta seguridad en todas las tarjetas!',
      scanInfo: '¡Descarga la app <b>PDF417</b> o <b>QR</b> para escanear tu ID!',
    },
    delivery: {
      line1: 'Discreto &',
      line2: 'Sin Marca,',
      line3: 'Envío Gratis',
      description: 'Cada pedido se envía en un empaque discreto, sin marcas. Sin logos, sin branding – tu tarjeta entregada de forma segura y privada.',
      cta: 'Ver todos los Modelos',
    },
    testimonials: {
      title: 'Lo que Dicen Nuestros',
      titleHighlight: 'Clientes',
      subtitle: 'Confianza de miles en todo el mundo',
      cta: 'Todas las Reseñas',
    },
    blog: {
      title: 'Blog',
      titleHighlight: '& Noticias',
      subtitle: 'Mantente al día con los últimos consejos, guías y noticias',
      posts: [
        { title: 'Cómo Elegir el Diseño Perfecto de ID Falsa', excerpt: 'Una guía completa para seleccionar el diseño de identificación adecuado para tus necesidades.', date: '28 Dic 2025', category: 'Guía' },
        { title: 'Top 5 Usos para Tarjetas de ID Personalizadas', excerpt: 'Descubre formas creativas en que las personas usan nuestras tarjetas de identificación premium.', date: '22 Dic 2025', category: 'Consejos' },
        { title: 'Nueva Tecnología de Hologramas en 2026', excerpt: 'Nos complace anunciar nuestra tecnología de hologramas de próxima generación.', date: '15 Dic 2025', category: 'Noticias' },
      ],
      readMore: 'Leer Más',
    },
    faq: {
      title: 'Preguntas',
      titleHighlight: 'Frecuentes',
      subtitle: 'Todo lo que necesitas saber sobre nuestras tarjetas de identificación falsas',
      items: [
        { question: '¿Cómo comprar una identificación falsa online de forma segura?', answer: 'Simplemente elige tu diseño en nuestra tienda de ID falsa, sube tu foto, personaliza los detalles y realiza el pago. Usamos procesamiento de pago seguro y envío discreto mundial.' },
        { question: '¿Qué hace que sus hologramas de ID falsa se vean auténticos?', answer: 'Nuestra tecnología de hologramas crea características de seguridad realistas que brillan y cambian de apariencia al inclinarlas. Cada tarjeta tiene capas holográficas múltiples.' },
        { question: '¿Cuánto tarda el envío de ID falsas a nivel mundial?', answer: 'El envío estándar tarda 7-14 días hábiles. Todos los pedidos se envían con empaque discreto. El seguimiento de pedidos estará disponible pronto.' },
        { question: '¿Sus tarjetas de identificación son escaneables?', answer: 'Sí, todas las tarjetas incluyen códigos QR y códigos de barras funcionales que se pueden escanear con lectores estándar y apps PDF417.' },
        { question: '¿Puedo personalizar mi licencia de conducir falsa?', answer: '¡Absolutamente! Cada campo se puede personalizar: nombre, dirección, fecha de nacimiento, foto y más. Nuestro constructor de tarjetas te permite previsualizar cambios en tiempo real.' },
        { question: '¿Cuál es la diferencia entre State ID y Photo ID?', answer: 'Las tarjetas State ID replican el diseño de documentos de identificación oficiales. Las Photo ID son tarjetas de identificación más genéricas para entretenimiento y novelty.' },
        { question: '¿Envían tarjetas de ID falsas a España y Latinoamérica?', answer: '¡Sí! Ofrecemos envío mundial incluyendo España, México, Argentina y toda Latinoamérica. Los pedidos suelen llegar en 7-14 días hábiles.' },
        { question: '¿Por qué los clientes confían en nuestra tienda de ID falsas?', answer: 'Desde 2007, más de 63,000 clientes satisfechos han confiado en Fake-ID.com. Lee nuestras 1,500+ reseñas verificadas para ver por qué somos la tienda más confiable.' },
        { question: '¿Qué métodos de pago aceptan?', answer: 'Aceptamos todas las tarjetas de crédito principales (Visa, Mastercard),  Apple Pay, Google Pay, transferencias SEPA y criptomonedas.' },
        { question: '¿Cuál es la calidad de sus tarjetas de identificación?', answer: 'Nuestras tarjetas premium se imprimen en PVC de 0.8mm – mismo grosor que tarjetas de crédito reales. Son resistentes al agua, duraderas y tienen hologramas y códigos de barras escaneables.' },
      ],
      footerText: '¿Tienes más preguntas sobre nuestra <b>tienda de ID falsas</b>? Consulta nuestra',
      guideLink: 'guía completa',
      or: 'o',
      contactLink: 'contacta a nuestro equipo de soporte',
      footerEnd: 'Únete a más de <b>63,000 clientes satisfechos</b> que confían en Fake-ID.com.',
    },
    process: {
      title1: 'SOLO TOMA',
      title2: 'UN MINUTO.',
      steps: [
        'Elige una plantilla de tarjeta prediseñada.',
        'Personaliza tu tarjeta y agrégala al carrito.',
        'Envía tu pedido y ¡listo!',
      ],
      cta: 'COMPRAR AHORA',
    },
    partners: {
      title: 'Fake-ID',
      titleHighlight: 'Partners',
      subtitle: 'Confianza de marcas líderes a nivel mundial',
    },
  },
  fr: {
    heroTitle1: 'Créez Votre',
    heroTitle2: '',
    heroTitleHighlight: 'Fausse Carte',
    stats: [
      { value: '63 497', label: 'Clients Satisfaits' },
      { value: '1 521', label: 'Avis 5 Étoiles' },
      { value: '8', label: 'Modèles de Cartes' },
      { value: '100%', label: 'Taux de Satisfaction' },
    ],
    howItWorks: {
      title: 'Comment ça Marche',
      subtitle: 'Obtenez votre carte d\'identité personnalisée en 3 étapes simples',
      steps: [
        { title: 'Choisir un Modèle', desc: 'Parcourez notre collection et sélectionnez votre design préféré' },
        { title: 'Personnaliser', desc: 'Téléchargez votre photo et entrez vos informations personnelles' },
        { title: 'Recevoir', desc: 'Livraison rapide et discrète à votre porte' },
      ],
    },
    holograms: {
      subtitle: 'Couches d\'',
      subtitleHighlight: 'hologramme',
      subtitleEnd: 'haute sécurité sur toutes les cartes !',
      scanInfo: 'Téléchargez l\'app <b>PDF417</b> ou <b>QR</b> pour scanner votre carte !',
    },
    delivery: {
      line1: 'Discret &',
      line2: 'Sans Marque,',
      line3: 'Livraison Gratuite',
      description: 'Chaque commande est expédiée dans un emballage neutre, sans marque. Aucun logo – votre carte livrée en toute sécurité et confidentialité.',
      cta: 'Voir tous les Modèles',
    },
    testimonials: {
      title: 'Ce que Disent Nos',
      titleHighlight: 'Clients',
      subtitle: 'La confiance de milliers de clients dans le monde',
      cta: 'Tous les Avis',
    },
    blog: {
      title: 'Blog',
      titleHighlight: '& Actualités',
      subtitle: 'Restez informé avec les derniers conseils, guides et actualités',
      posts: [
        { title: 'Comment Choisir le Design Parfait de Fausse Carte', excerpt: 'Un guide complet pour sélectionner le bon design de carte d\'identité pour vos besoins.', date: '28 Déc 2025', category: 'Guide' },
        { title: 'Top 5 des Utilisations pour les Cartes ID Personnalisées', excerpt: 'Découvrez des façons créatives d\'utiliser nos cartes d\'identité premium dans le monde.', date: '22 Déc 2025', category: 'Conseils' },
        { title: 'Nouvelle Technologie Hologramme en 2026', excerpt: 'Nous sommes ravis d\'annoncer notre technologie holographique de nouvelle génération.', date: '15 Déc 2025', category: 'Actualités' },
      ],
      readMore: 'Lire la Suite',
    },
    faq: {
      title: 'Questions',
      titleHighlight: 'Fréquentes',
      subtitle: 'Tout ce que vous devez savoir sur nos fausses cartes d\'identité',
      items: [
        { question: 'Comment acheter une fausse carte d\'identité en ligne en toute sécurité ?', answer: 'Choisissez simplement votre design dans notre boutique de fausses cartes, téléchargez votre photo, personnalisez les détails et passez à la caisse. Nous utilisons un traitement de paiement sécurisé et une livraison discrète dans le monde entier.' },
        { question: 'Qu\'est-ce qui rend vos hologrammes de fausse carte si authentiques ?', answer: 'Notre technologie holographique propriétaire crée des éléments de sécurité réalistes qui scintillent et changent d\'apparence quand on les incline. Chaque carte comporte des superpositions holographiques multi-couches.' },
        { question: 'Combien de temps prend la livraison des fausses cartes dans le monde ?', answer: 'La livraison standard prend 7-14 jours ouvrés. Toutes les commandes sont expédiées dans un emballage discret. Le suivi des commandes sera bientôt disponible.' },
        { question: 'Vos cartes d\'identité novelty sont-elles scannables ?', answer: 'Oui, toutes les cartes incluent des QR codes et codes-barres fonctionnels qui peuvent être scannés avec des lecteurs standard et des apps PDF417.' },
        { question: 'Puis-je personnaliser mon faux permis de conduire ?', answer: 'Absolument ! Chaque champ peut être personnalisé – nom, adresse, date de naissance, photo et plus. Notre constructeur de cartes vous permet de prévisualiser les changements en temps réel.' },
        { question: 'Quelle est la différence entre State ID et Photo ID ?', answer: 'Les cartes State ID reproduisent le design de documents d\'identification officiels. Les Photo ID sont des cartes plus génériques adaptées au divertissement et aux usages novelty.' },
        { question: 'Livrez-vous des fausses cartes en France et en Europe ?', answer: 'Oui ! Nous offrons la livraison mondiale incluant la France, la Belgique, la Suisse et tous les pays européens. Les commandes UE arrivent généralement sous 7-10 jours ouvrés.' },
        { question: 'Pourquoi les clients font-ils confiance à notre boutique ?', answer: 'Depuis 2007, plus de 63 000 clients satisfaits font confiance à Fake-ID.com. Lisez nos 1 500+ avis vérifiés pour découvrir pourquoi nous sommes la boutique la plus fiable.' },
        { question: 'Quels modes de paiement acceptez-vous ?', answer: 'Nous acceptons toutes les cartes de crédit (Visa, Mastercard),  Apple Pay, Google Pay, virements SEPA et cryptomonnaies. Toutes les transactions sont chiffrées.' },
        { question: 'Quelle est la qualité de vos cartes d\'identité novelty ?', answer: 'Nos cartes premium sont imprimées sur du PVC de 0,8mm – épaisseur identique aux vraies cartes de crédit. Elles sont étanches, durables et comportent des hologrammes et codes-barres scannables.' },
      ],
      footerText: 'Vous avez d\'autres questions sur notre <b>boutique de fausses cartes</b> ? Consultez notre',
      guideLink: 'guide complet',
      or: 'ou',
      contactLink: 'contactez notre équipe support',
      footerEnd: 'Rejoignez plus de <b>63 000 clients satisfaits</b> qui font confiance à Fake-ID.com.',
    },
    process: {
      title1: 'ÇA NE PREND QU\'',
      title2: 'UNE MINUTE.',
      steps: [
        'Choisissez un modèle de carte prédéfini.',
        'Personnalisez votre carte et ajoutez-la au panier.',
        'Validez votre commande et c\'est parti !',
      ],
      cta: 'ACHETER MAINTENANT',
    },
    partners: {
      title: 'Fake-ID',
      titleHighlight: 'Partenaires',
      subtitle: 'La confiance des marques leaders dans le monde',
    },
  },
  it: {
    heroTitle1: 'Crea La Tua',
    heroTitle2: '',
    heroTitleHighlight: 'Carta Falsa',
    stats: [
      { value: '63.497', label: 'Clienti Soddisfatti' },
      { value: '1.521', label: 'Recensioni 5 Stelle' },
      { value: '8', label: 'Design di Carte' },
      { value: '100%', label: 'Tasso di Soddisfazione' },
    ],
    howItWorks: {
      title: 'Come Funziona',
      subtitle: 'Ottieni la tua carta d\'identità personalizzata in 3 semplici passi',
      steps: [
        { title: 'Scegli un Modello', desc: 'Sfoglia la nostra collezione e seleziona il tuo design preferito' },
        { title: 'Personalizza', desc: 'Carica la tua foto e inserisci i tuoi dati personali' },
        { title: 'Ricevi', desc: 'Consegna rapida e discreta a casa tua' },
      ],
    },
    holograms: {
      subtitle: 'Strati di',
      subtitleHighlight: 'ologramma',
      subtitleEnd: 'ad alta sicurezza su tutte le carte!',
      scanInfo: 'Scarica l\'app <b>PDF417</b> o <b>QR</b> per scansionare la tua carta!',
    },
    delivery: {
      line1: 'Discreto &',
      line2: 'Senza Marchio,',
      line3: 'Spedizione Gratuita',
      description: 'Ogni ordine viene spedito in un imballaggio neutro, senza marchi. Nessun logo – la tua carta consegnata in modo sicuro e privato.',
      cta: 'Vedi tutti i Modelli',
    },
    testimonials: {
      title: 'Cosa Dicono i Nostri',
      titleHighlight: 'Clienti',
      subtitle: 'La fiducia di migliaia di clienti nel mondo',
      cta: 'Tutte le Recensioni',
    },
    blog: {
      title: 'Blog',
      titleHighlight: '& Notizie',
      subtitle: 'Resta aggiornato con gli ultimi consigli, guide e novità',
      posts: [
        { title: 'Come Scegliere il Design Perfetto per la Tua ID Falsa', excerpt: 'Una guida completa per selezionare il giusto design di carta d\'identità per le tue esigenze.', date: '28 Dic 2025', category: 'Guida' },
        { title: 'Top 5 Usi per Carte ID Personalizzate', excerpt: 'Scopri modi creativi in cui le persone usano le nostre carte d\'identità premium nel mondo.', date: '22 Dic 2025', category: 'Consigli' },
        { title: 'Nuova Tecnologia Ologramma nel 2026', excerpt: 'Siamo entusiasti di annunciare la nostra tecnologia olografica di nuova generazione.', date: '15 Dic 2025', category: 'Notizie' },
      ],
      readMore: 'Leggi di Più',
    },
    faq: {
      title: 'Domande',
      titleHighlight: 'Frequenti',
      subtitle: 'Tutto quello che devi sapere sulle nostre carte d\'identità false',
      items: [
        { question: 'Come comprare una carta d\'identità falsa online in sicurezza?', answer: 'Scegli semplicemente il tuo design nel nostro negozio di carte false, carica la tua foto, personalizza i dettagli e procedi al pagamento. Usiamo elaborazione sicura dei pagamenti e spedizione discreta mondiale.' },
        { question: 'Cosa rende i vostri ologrammi così autentici?', answer: 'La nostra tecnologia olografica crea caratteristiche di sicurezza realistiche che brillano e cambiano aspetto quando inclinati. Ogni carta ha sovrapposizioni olografiche multi-strato.' },
        { question: 'Quanto tempo impiega la spedizione nel mondo?', answer: 'La spedizione standard richiede 7-14 giorni lavorativi. Tutti gli ordini vengono spediti con imballaggio discreto. Il tracciamento degli ordini sarà disponibile a breve.' },
        { question: 'Le vostre carte di identità novelty sono scansionabili?', answer: 'Sì, tutte le carte includono QR code e codici a barre funzionali scansionabili con lettori standard e app PDF417.' },
        { question: 'Posso personalizzare la mia patente falsa?', answer: 'Assolutamente! Ogni campo può essere personalizzato – nome, indirizzo, data di nascita, foto e altro. Il nostro costruttore di carte ti permette di vedere le modifiche in tempo reale.' },
        { question: 'Qual è la differenza tra State ID e Photo ID?', answer: 'Le carte State ID replicano il design di documenti di identificazione ufficiali. Le Photo ID sono carte più generiche adatte a scopi di intrattenimento e novelty.' },
        { question: 'Spedite carte false in Italia e in Europa?', answer: 'Sì! Offriamo spedizione mondiale inclusa Italia e tutti i paesi europei. Gli ordini UE arrivano solitamente in 7-10 giorni lavorativi.' },
        { question: 'Perché i clienti si fidano del nostro negozio?', answer: 'Dal 2007, oltre 63.000 clienti soddisfatti si fidano di Fake-ID.com. Leggi le nostre 1.500+ recensioni verificate.' },
        { question: 'Quali metodi di pagamento accettate?', answer: 'Accettiamo tutte le carte di credito (Visa, Mastercard),  Apple Pay, Google Pay, bonifici SEPA e criptovalute. Tutte le transazioni sono crittografate.' },
        { question: 'Qual è la qualità delle vostre carte novelty?', answer: 'Le nostre carte premium sono stampate su PVC da 0,8mm – spessore identico alle carte di credito reali. Sono impermeabili, durevoli e hanno ologrammi e codici a barre scansionabili.' },
      ],
      footerText: 'Hai altre domande sul nostro <b>negozio di carte false</b>? Consulta la nostra',
      guideLink: 'guida completa',
      or: 'o',
      contactLink: 'contatta il nostro team di supporto',
      footerEnd: 'Unisciti a oltre <b>63.000 clienti soddisfatti</b> che si fidano di Fake-ID.com.',
    },
    process: {
      title1: 'CI VUOLE SOLO',
      title2: 'UN MINUTO.',
      steps: [
        'Scegli un modello di carta predefinito.',
        'Personalizza la tua carta e aggiungila al carrello.',
        'Invia il tuo ordine e sei a posto!',
      ],
      cta: 'ACQUISTA ORA',
    },
    partners: {
      title: 'Fake-ID',
      titleHighlight: 'Partner',
      subtitle: 'La fiducia dei brand leader a livello mondiale',
    },
  },
  pt: {
    heroTitle1: 'Crie Sua',
    heroTitle2: 'Própria',
    heroTitleHighlight: 'ID Falsa',
    stats: [
      { value: '63.497', label: 'Clientes Satisfeitos' },
      { value: '1.521', label: 'Avaliações 5 Estrelas' },
      { value: '8', label: 'Designs de Cartões' },
      { value: '100%', label: 'Taxa de Satisfação' },
    ],
    howItWorks: {
      title: 'Como Funciona',
      subtitle: 'Obtenha seu cartão de identidade personalizado em 3 passos simples',
      steps: [
        { title: 'Escolha um Modelo', desc: 'Navegue pela nossa coleção e selecione seu design preferido' },
        { title: 'Personalize', desc: 'Faça upload da sua foto e insira seus dados pessoais' },
        { title: 'Receba', desc: 'Entrega rápida e discreta na sua porta' },
      ],
    },
    holograms: {
      subtitle: 'Camadas de',
      subtitleHighlight: 'holograma',
      subtitleEnd: 'de alta segurança em todos os cartões!',
      scanInfo: 'Baixe o app <b>PDF417</b> ou <b>QR</b> para escanear seu ID!',
    },
    delivery: {
      line1: 'Discreto &',
      line2: 'Sem Marca,',
      line3: 'Frete Grátis',
      description: 'Cada pedido é enviado em embalagem discreta, sem marcas. Sem logos, sem branding – seu cartão entregue com segurança e privacidade.',
      cta: 'Ver todos os Modelos',
    },
    testimonials: {
      title: 'O que Nossos Clientes',
      titleHighlight: 'Dizem',
      subtitle: 'Confiança de milhares em todo o mundo',
      cta: 'Todas as Avaliações',
    },
    blog: {
      title: 'Blog',
      titleHighlight: '& Notícias',
      subtitle: 'Fique atualizado com as últimas dicas, guias e novidades',
      posts: [
        { title: 'Como Escolher o Design Perfeito de ID Falsa', excerpt: 'Um guia completo para selecionar o design certo de identificação para suas necessidades.', date: '28 Dez 2025', category: 'Guia' },
        { title: 'Top 5 Usos para Cartões de ID Personalizados', excerpt: 'Descubra formas criativas de usar nossos cartões de identificação premium.', date: '22 Dez 2025', category: 'Dicas' },
        { title: 'Nova Tecnologia de Holograma em 2026', excerpt: 'Estamos empolgados em anunciar nossa tecnologia holográfica de próxima geração.', date: '15 Dez 2025', category: 'Notícias' },
      ],
      readMore: 'Leia Mais',
    },
    faq: {
      title: 'Perguntas',
      titleHighlight: 'Frequentes',
      subtitle: 'Tudo o que você precisa saber sobre nossos cartões de identificação falsos',
      items: [
        { question: 'Como comprar uma identidade falsa online com segurança?', answer: 'Simplesmente escolha seu design na nossa loja de ID falsa, faça upload da sua foto, personalize os detalhes e finalize a compra. Usamos processamento de pagamento seguro e envio discreto mundial.' },
        { question: 'O que torna seus hologramas tão autênticos?', answer: 'Nossa tecnologia holográfica cria recursos de segurança realistas que brilham e mudam de aparência ao serem inclinados. Cada cartão tem sobreposições holográficas multi-camadas.' },
        { question: 'Quanto tempo demora o envio de ID falsas no mundo?', answer: 'O envio padrão leva 7-14 dias úteis. Todos os pedidos são enviados com embalagem discreta. O rastreamento de pedidos estará disponível em breve.' },
        { question: 'Seus cartões de identificação são escaneáveis?', answer: 'Sim, todos os cartões incluem QR codes e códigos de barras funcionais que podem ser escaneados com leitores padrão e apps PDF417.' },
        { question: 'Posso personalizar minha carteira de motorista falsa?', answer: 'Com certeza! Cada campo pode ser personalizado – nome, endereço, data de nascimento, foto e mais. Nosso construtor de cartões permite visualizar mudanças em tempo real.' },
        { question: 'Qual a diferença entre State ID e Photo ID?', answer: 'Cartões State ID replicam o design de documentos de identificação oficiais. Photo ID são cartões mais genéricos adequados para entretenimento e novelty.' },
        { question: 'Vocês enviam cartões para o Brasil e Portugal?', answer: 'Sim! Oferecemos envio mundial incluindo Brasil, Portugal e toda a América Latina. Os pedidos geralmente chegam em 10-14 dias úteis.' },
        { question: 'Por que os clientes confiam na nossa loja?', answer: 'Desde 2007, mais de 63.000 clientes satisfeitos confiam na Fake-ID.com. Leia nossas 1.500+ avaliações verificadas.' },
        { question: 'Quais métodos de pagamento vocês aceitam?', answer: 'Aceitamos todos os cartões de crédito (Visa, Mastercard),  Apple Pay, Google Pay, transferências SEPA e criptomoedas.' },
        { question: 'Qual é a qualidade dos seus cartões novelty?', answer: 'Nossos cartões premium são impressos em PVC de 0,8mm – espessura idêntica a cartões de crédito reais. São à prova d\'água, duráveis e têm hologramas e códigos de barras escaneáveis.' },
      ],
      footerText: 'Tem mais perguntas sobre nossa <b>loja de ID falsas</b>? Confira nosso',
      guideLink: 'guia completo',
      or: 'ou',
      contactLink: 'entre em contato com nossa equipe',
      footerEnd: 'Junte-se a mais de <b>63.000 clientes satisfeitos</b> que confiam na Fake-ID.com.',
    },
    process: {
      title1: 'LEVA APENAS',
      title2: 'UM MINUTO.',
      steps: [
        'Escolha um modelo de cartão predefinido.',
        'Personalize seu cartão e adicione ao carrinho.',
        'Envie seu pedido e pronto!',
      ],
      cta: 'COMPRAR AGORA',
    },
    partners: {
      title: 'Fake-ID',
      titleHighlight: 'Parceiros',
      subtitle: 'Confiança de marcas líderes em todo o mundo',
    },
  },
  ru: {
    heroTitle1: 'Создайте Свой',
    heroTitle2: '',
    heroTitleHighlight: 'Фейк ID',
    stats: [
      { value: '63 497', label: 'Довольных Клиентов' },
      { value: '1 521', label: 'Отзывов на 5 Звёзд' },
      { value: '8', label: 'Дизайнов Карт' },
      { value: '100%', label: 'Уровень Удовлетворённости' },
    ],
    howItWorks: {
      title: 'Как Это Работает',
      subtitle: 'Получите ваше удостоверение за 3 простых шага',
      steps: [
        { title: 'Выберите Шаблон', desc: 'Просмотрите нашу коллекцию и выберите понравившийся дизайн' },
        { title: 'Настройте', desc: 'Загрузите фото и введите свои данные' },
        { title: 'Получите', desc: 'Быстрая, дискретная доставка к вашей двери' },
      ],
    },
    holograms: {
      subtitle: 'Высокозащищённые',
      subtitleHighlight: 'голограммы',
      subtitleEnd: 'на всех картах!',
      scanInfo: 'Скачайте приложение <b>PDF417</b> или <b>QR</b> для сканирования!',
    },
    delivery: {
      line1: 'Дискретно &',
      line2: 'Без Бренда,',
      line3: 'Бесплатная Доставка',
      description: 'Каждый заказ отправляется в обычной, немаркированной упаковке. Без логотипов — ваша карта доставлена безопасно и конфиденциально.',
      cta: 'Смотреть все Модели',
    },
    testimonials: {
      title: 'Что Говорят Наши',
      titleHighlight: 'Клиенты',
      subtitle: 'Доверие тысяч клиентов по всему миру',
      cta: 'Все Отзывы',
    },
    blog: {
      title: 'Блог',
      titleHighlight: '& Новости',
      subtitle: 'Будьте в курсе последних советов, руководств и новостей',
      posts: [
        { title: 'Как Выбрать Идеальный Дизайн Поддельного ID', excerpt: 'Полное руководство по выбору подходящего дизайна удостоверения для ваших нужд.', date: '28 Дек 2025', category: 'Руководство' },
        { title: 'Топ 5 Применений Персонализированных ID Карт', excerpt: 'Откройте для себя креативные способы использования наших ID карт по всему миру.', date: '22 Дек 2025', category: 'Советы' },
        { title: 'Новая Технология Голограмм в 2026', excerpt: 'Мы рады представить нашу голографическую технологию нового поколения.', date: '15 Дек 2025', category: 'Новости' },
      ],
      readMore: 'Читать Далее',
    },
    faq: {
      title: 'Часто Задаваемые',
      titleHighlight: 'Вопросы',
      subtitle: 'Всё, что вам нужно знать о наших поддельных удостоверениях',
      items: [
        { question: 'Как купить поддельное удостоверение онлайн безопасно?', answer: 'Просто выберите дизайн в нашем магазине, загрузите фото, настройте данные и оформите заказ. Мы используем безопасную обработку платежей и дискретную доставку по всему миру.' },
        { question: 'Что делает ваши голограммы такими реалистичными?', answer: 'Наша технология голограмм создаёт реалистичные элементы безопасности, которые переливаются при наклоне. Каждая карта имеет многослойные голографические наложения.' },
        { question: 'Сколько времени занимает доставка по миру?', answer: 'Стандартная доставка занимает 7-14 рабочих дней. Все заказы отправляются в дискретной упаковке. Отслеживание заказов скоро будет доступно.' },
        { question: 'Ваши удостоверения сканируются?', answer: 'Да, все карты включают функциональные QR-коды и штрих-коды, которые можно сканировать стандартными считывателями и приложениями PDF417.' },
        { question: 'Могу ли я настроить своё поддельное водительское удостоверение?', answer: 'Конечно! Каждое поле может быть настроено – имя, адрес, дата рождения, фото и многое другое. Наш конструктор карт позволяет просматривать изменения в реальном времени.' },
        { question: 'В чём разница между State ID и Photo ID?', answer: 'Карты State ID воспроизводят дизайн официальных документов. Photo ID — более универсальные карты для развлечений и коллекционирования.' },
        { question: 'Вы доставляете в Россию и СНГ?', answer: 'Да! Мы предлагаем мировую доставку, включая Россию и все страны СНГ. Заказы обычно прибывают в течение 10-14 рабочих дней.' },
        { question: 'Почему клиенты доверяют нашему магазину?', answer: 'С 2007 года более 63 000 клиентов доверяют Fake-ID.com. Читайте наши 1 500+ проверенных отзывов.' },
        { question: 'Какие способы оплаты вы принимаете?', answer: 'Мы принимаем все основные кредитные карты (Visa, Mastercard),  Apple Pay, Google Pay, SEPA переводы и криптовалюту.' },
        { question: 'Какое качество ваших карт?', answer: 'Наши карты печатаются на ПВХ 0,8мм – такая же толщина, как у настоящих кредитных карт. Они водонепроницаемы, долговечны и имеют голограммы и сканируемые штрих-коды.' },
      ],
      footerText: 'Есть ещё вопросы о нашем <b>магазине фейковых ID</b>? Ознакомьтесь с нашим',
      guideLink: 'полным руководством',
      or: 'или',
      contactLink: 'свяжитесь с нашей командой поддержки',
      footerEnd: 'Присоединяйтесь к более чем <b>63 000 довольных клиентов</b>, которые доверяют Fake-ID.com.',
    },
    process: {
      title1: 'ЭТО ЗАЙМЁТ ВСЕГО',
      title2: 'МИНУТУ.',
      steps: [
        'Выберите готовый шаблон карты.',
        'Персонализируйте карту и добавьте в корзину.',
        'Оформите заказ — и готово!',
      ],
      cta: 'КУПИТЬ СЕЙЧАС',
    },
    partners: {
      title: 'Fake-ID',
      titleHighlight: 'Партнёры',
      subtitle: 'Доверие ведущих брендов по всему миру',
    },
  },
  sv: {
    heroTitle1: 'Skapa Ditt',
    heroTitle2: '',
    heroTitleHighlight: 'Falskt ID',
    stats: [
      { value: '63 497', label: 'Nöjda Kunder' },
      { value: '1 521', label: '5-Stjärniga Recensioner' },
      { value: '8', label: 'Kortdesigner' },
      { value: '100%', label: 'Nöjdhetsgrad' },
    ],
    howItWorks: {
      title: 'Så Fungerar Det',
      subtitle: 'Få ditt anpassade ID-kort i 3 enkla steg',
      steps: [
        { title: 'Välj en Mall', desc: 'Bläddra i vår kollektion och välj din favoritdesign' },
        { title: 'Anpassa', desc: 'Ladda upp ditt foto och ange dina personuppgifter' },
        { title: 'Få Det', desc: 'Snabb, diskret leverans direkt till din dörr' },
      ],
    },
    holograms: {
      subtitle: 'Högsakra',
      subtitleHighlight: 'hologram',
      subtitleEnd: 'lager på alla kort!',
      scanInfo: 'Ladda ner <b>PDF417</b>- eller <b>QR</b>-appen för att skanna ditt ID!',
    },
    delivery: {
      line1: 'Diskret &',
      line2: 'Ingen Märkning,',
      line3: 'Fri Frakt',
      description: 'Varje beställning skickas i diskret, omärkt förpackning. Inga logotyper – ditt kort levereras säkert och privat.',
      cta: 'Visa alla Modeller',
    },
    testimonials: {
      title: 'Vad Våra Kunder',
      titleHighlight: 'Säger',
      subtitle: 'Betrodd av tusentals världen över',
      cta: 'Alla Recensioner',
    },
    blog: {
      title: 'Blogg',
      titleHighlight: '& Nyheter',
      subtitle: 'Håll dig uppdaterad med de senaste tipsen, guiderna och nyheterna',
      posts: [
        { title: 'Hur du Väljer den Perfekta Novelty ID-Designen', excerpt: 'En komplett guide för att välja rätt ID-design för dina behov.', date: '28 Dec 2025', category: 'Guide' },
        { title: 'Topp 5 Användningar för Anpassade ID-Kort', excerpt: 'Upptäck kreativa sätt som människor använder våra premium novelty ID-kort.', date: '22 Dec 2025', category: 'Tips' },
        { title: 'Ny Hologramteknik 2026', excerpt: 'Vi är glada att presentera vår nästa generations hologramteknik.', date: '15 Dec 2025', category: 'Nyheter' },
      ],
      readMore: 'Läs Mer',
    },
    faq: {
      title: 'Vanliga',
      titleHighlight: 'Frågor',
      subtitle: 'Allt du behöver veta om våra falska ID-kort och novelty-produkter',
      items: [
        { question: 'Hur beställer jag ett falskt ID online säkert?', answer: 'Välj din kortdesign i vår butik, ladda upp ditt foto, anpassa detaljerna och gå till kassan. Vi använder säker betalningshantering och diskret leverans världen över.' },
        { question: 'Vad gör era hologram så autentiska?', answer: 'Vår hologramteknik skapar realistiska säkerhetsfunktioner som skimrar vid lutning. Varje kort har flerskiktade holografiska överlägg.' },
        { question: 'Hur lång tid tar leveransen?', answer: 'Standardleverans tar 7-14 arbetsdagar. Alla beställningar skickas med diskret förpackning.' },
        { question: 'Är era novelty-kort skannbara?', answer: 'Ja, alla kort inkluderar funktionella QR-koder och streckkoder som kan skannas med standardläsare och PDF417-appar.' },
        { question: 'Kan jag anpassa mitt falska körkort?', answer: 'Absolut! Varje fält kan anpassas – namn, adress, födelsedatum, foto och mer.' },
        { question: 'Skickar ni till Sverige och Europa?', answer: 'Ja! Vi erbjuder världsomspännande leverans inklusive Sverige och alla europeiska länder.' },
        { question: 'Varför litar kunder på vår butik?', answer: 'Sedan 2007 har över 63 000 nöjda kunder litat på Fake-ID.com.' },
        { question: 'Vilka betalningsmetoder accepterar ni?', answer: 'Vi accepterar alla större kreditkort (Visa, Mastercard), Apple Pay, Google Pay, SEPA-överföringar och kryptovaluta.' },
        { question: 'Vilken kvalitet har era novelty-kort?', answer: 'Våra premiumkort trycks på 0,8mm PVC – samma tjocklek som riktiga kreditkort. De är vattentäta och har hologram och skannbara streckkoder.' },
        { question: 'Vad är skillnaden mellan State ID och Photo ID?', answer: 'State ID-kort replikerar designen av officiella ID-handlingar. Photo ID-kort är mer generiska identitetskort.' },
      ],
      footerText: 'Har du fler frågor om vår <b>falska ID-butik</b>? Kolla in vår',
      guideLink: 'kompletta guide',
      or: 'eller',
      contactLink: 'kontakta vårt supportteam',
      footerEnd: 'Gå med i över <b>63 000 nöjda kunder</b> som litar på Fake-ID.com.',
    },
    process: {
      title1: 'DET TAR BARA',
      title2: 'EN MINUT.',
      steps: [
        'Välj en färdig kortmall.',
        'Anpassa ditt kort och lägg det i kundvagnen.',
        'Skicka din beställning och du är klar!',
      ],
      cta: 'HANDLA NU',
    },
    partners: {
      title: 'Fake-ID',
      titleHighlight: 'Partners',
      subtitle: 'Betrodd av ledande varumärken världen över',
    },
  },
  zh: {
    heroTitle1: '创建您的',
    heroTitle2: '专属',
    heroTitleHighlight: '仿真证件',
    stats: [
      { value: '63,497', label: '满意客户' },
      { value: '1,521', label: '五星评价' },
      { value: '8', label: '卡片设计' },
      { value: '100%', label: '满意率' },
    ],
    howItWorks: {
      title: '如何运作',
      subtitle: '3个简单步骤获取您的定制ID卡',
      steps: [
        { title: '选择模板', desc: '浏览我们的系列并选择您喜欢的设计' },
        { title: '自定义', desc: '上传您的照片并输入您的个人信息' },
        { title: '收货', desc: '快速、低调的配送到您家门' },
      ],
    },
    holograms: {
      subtitle: '高安全',
      subtitleHighlight: '全息图',
      subtitleEnd: '层覆盖所有卡片！',
      scanInfo: '下载<b>PDF417</b>或<b>QR</b>应用扫描您的ID！',
    },
    delivery: {
      line1: '低调，',
      line2: '无品牌标识',
      line3: '免费配送',
      description: '每个订单都以低调、无标记的包装发送。没有标志，没有品牌——您的卡片安全私密地送达。',
      cta: '查看所有型号',
    },
    testimonials: {
      title: '我们的客户',
      titleHighlight: '怎么说',
      subtitle: '全球数千人的信赖之选',
      cta: '所有评价',
    },
    blog: {
      title: '博客',
      titleHighlight: '与新闻',
      subtitle: '了解最新的技巧、指南和新闻',
      posts: [
        { title: '如何选择完美的新奇ID设计', excerpt: '选择适合您需求的ID设计的完整指南。', date: '2025年12月28日', category: '指南' },
        { title: '定制ID卡的5大用途', excerpt: '发现人们使用我们的优质新奇ID卡的创意方式。', date: '2025年12月22日', category: '技巧' },
        { title: '2026年新全息图技术', excerpt: '我们很高兴地宣布我们的下一代全息图技术。', date: '2025年12月15日', category: '新闻' },
      ],
      readMore: '阅读更多',
    },
    faq: {
      title: '常见',
      titleHighlight: '问题',
      subtitle: '关于我们的仿真ID卡和新奇产品的一切',
      items: [
        { question: '如何安全地在线订购仿真ID？', answer: '只需在我们的商店中选择您的卡片设计，上传照片，自定义详细信息，然后结账。我们使用安全的支付处理和全球低调配送。' },
        { question: '是什么让您的全息图看起来如此真实？', answer: '我们的全息图技术创造出逼真的安全特征，倾斜时会闪烁变化。每张卡片都有多层全息覆盖。' },
        { question: '全球配送需要多长时间？', answer: '标准配送需要7-14个工作日。所有订单都以低调包装发送。' },
        { question: '您的新奇证件可以扫描吗？', answer: '是的，所有卡片都包含功能性QR码和条形码，可以用标准读取器和PDF417应用扫描。' },
        { question: '我可以自定义我的仿真驾照吗？', answer: '当然可以！每个字段都可以自定义——姓名、地址、出生日期、照片等。' },
        { question: '你们配送到中国吗？', answer: '是的！我们提供全球配送，包括中国和亚洲所有国家。' },
        { question: '为什么客户信赖我们的商店？', answer: '自2007年以来，超过63,000位满意客户信赖Fake-ID.com。' },
        { question: '你们接受哪些付款方式？', answer: '我们接受所有主要信用卡（Visa，Mastercard），Apple Pay，Google Pay，SEPA转账和加密货币。' },
        { question: '您的新奇卡片质量如何？', answer: '我们的优质卡片印刷在0.8mm PVC上——与真实信用卡相同的厚度。防水、耐用，配有全息图和可扫描条形码。' },
        { question: 'State ID和Photo ID有什么区别？', answer: 'State ID卡复制了官方身份证件的设计。Photo ID卡是更通用的身份证卡。' },
      ],
      footerText: '对我们的<b>仿真ID商店</b>有更多问题？查看我们的',
      guideLink: '完整指南',
      or: '或',
      contactLink: '联系我们的支持团队',
      footerEnd: '加入超过<b>63,000位满意客户</b>，他们信赖Fake-ID.com。',
    },
    process: {
      title1: '只需',
      title2: '一分钟。',
      steps: [
        '选择一个预设计的卡片模板。',
        '个性化您的卡片并添加到购物车。',
        '提交您的订单，一切就绪。',
      ],
      cta: '立即购买',
    },
    partners: {
      title: 'Fake-ID',
      titleHighlight: '合作伙伴',
      subtitle: '全球领先品牌的信赖之选',
    },
  },
};

export type IndexContentType = typeof indexContent.en;
